import Swal from 'sweetalert2'

const success = (text) => {
    return new Promise((resolve) => {
        Swal.fire({
            title: "Merci!",
            text: text,
            icon: "success"
        });
    });
};

export default success;